/**
 * Returns "#000" or "#fff" — whichever has sufficient contrast against bgHex
 * per WCAG-AA relative luminance (threshold: 0.179, i.e. 3:1 against white).
 */
export function pickReadableTextColor(bgHex: string): '#000' | '#fff' {
  const hex = bgHex.replace(/^#/, '')
  const full =
    hex.length === 3
      ? hex
          .split('')
          .map((c) => c + c)
          .join('')
      : hex

  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)

  // Convert sRGB to linear
  const linearize = (c: number): number => {
    const s = c / 255
    return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
  }

  const L = 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b)

  // WCAG relative luminance threshold: white (L=1) has contrast ratio 1.0
  // Black is 0; threshold 0.179 gives ~4.5:1 against black
  return L > 0.179 ? '#000' : '#fff'
}
